import { lazy } from "react"
import { RouteProps } from "../features.types"

const ReferAndEarn = lazy(() => import("./refer-and-earn"))
const Settings = lazy(() => import("./settings"))
const ProfileController = lazy(() => import("./controller"))

// define route constant
export const EDIT_PROFILE_ROUTE = "profile"
export const REFER_AND_EARN_ROUTE = "profile/refer-and-earn"

//define routes
export const Profile: RouteProps[] = [
  {
    path: EDIT_PROFILE_ROUTE,
    Component: ProfileController,
    children: [
      {
        index: true,
        Component: Settings,
      },
      {
        path: `/${REFER_AND_EARN_ROUTE}`,
        Component: ReferAndEarn,
      },
    ],
  },
]
